const baseUrl = process.env.REACT_APP_API_BASE || "";

export default function api(path) {
  return `${baseUrl}${path}`;
}
